import React, { Component } from "react";
import { Card, Row, Col, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import DataTable from "react-data-table-component";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { connect } from "react-redux";
import { SuperAdminAction, TicketActions } from "../../Actions";
import Loader from "../Loader/Loader";
import { tableHeightScrollBars, findBySearch, scroolToTop } from "../helper";
import "react-datepicker/dist/react-datepicker.css";
import PropertDetails from "../LandingPage/PropertySelection";
import { saveAs } from "file-saver";
import moment from "moment";

class TotalReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PropertyId: this.props.PropertyId,
      paidUnpaidList: [],
      loader: false,
      searchValue: "",
      api_response: false,
      show_alert: false,
      api_success_message: "",
      api_error_message: "",
      count: 0,
      timezone: this.props.timezone,
      property: this.props.property,
      selectedPropertyObj: {},
      all_properties: [],
      childcheckbox: true,
      activeTab: "1",
      exportButtonDisable: true,
      finalTableHeight: 0,
    };

    this.customStyles = {
      rows: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };

    this.columns = [
      {
        name: "Domain",
        width: "130px",
        sortable: true,
        cell: (row) => this.showDomainField(row),
        selector: (row) => row?.domain,
      },
      {
        name: "Mon",
        width: "100px",
        sortable: true,
        cell: (row) => this.showMonField(row),
        selector: (row) => row.mon,
      },
      {
        name: "Month",
        width: "130px",
        sortable: true,
        cell: (row) => this.showMonthField(row),
        selector: (row) => row?.month,
      },
      {
        name: "Issued #",
        width: "100px",
        sortable: true,
        cell: (row) => this.showIssuedCountField(row),
        selector: (row) => row?.issued,
      },
      {
        name: "Issued $",
        width: "100px",
        sortable: true,
        cell: (row) => this.showIssuedFeeField(row),
        selector: (row) => row?.issuedFee,
      },
      {
        name: "Payable #",
        width: "100px",
        sortable: true,
        cell: (row) => this.showActualCitationField(row),
        selector: (row) => row?.actualCitations,
      },
      {
        name: "Payable $",
        width: "100px",
        sortable: true,
        cell: (row) => this.showActualFeeField(row),
        selector: (row) => row?.actualFee,
      },
      {
        name: "Paid #",
        width: "100px",
        sortable: true,
        cell: (row) => this.showPaidField(row),
        selector: (row) => row?.paid,
      },
      {
        name: "Paid $",
        width: "100px",
        sortable: true,
        cell: (row) => this.showPaidFeeField(row),
        selector: (row) => row?.paidFee,
      },
      {
        name: "Paid # %",
        width: "130px",
        sortable: true,
        cell: (row) => this.showActualPaidPerField(row),
        selector: (row) => row?.actualPaidPer,
      },
      {
        name: "Refund $",
        sortable: true,
        width: "100px",
        cell: (row) => this.showRefundFeeField(row),
        selector: (row) => row.refundFee,
      },
      {
        name: "Refund # %",
        sortable: true,
        width: "120px",
        cell: (row) => this.showRefundPerField(row),
        selector: (row) => row.refundPer,
      },
    ];
  }

  showRefundPerField = (row) => (
    <>
      {row.refundPer ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row.refundPer}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row.refundPer}</div>
        </OverlayTrigger>
      ) : (
        "0"
      )}
    </>
  );

  showRefundFeeField = (row) => (
    <>
      {row.refundFee ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>${row.refundFee}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">${row.refundFee}</div>
        </OverlayTrigger>
      ) : (
        "0"
      )}
    </>
  );

  showActualPaidPerField = (row) => (
    <>
      {row?.actualPaidPer ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.actualPaidPer}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row?.actualPaidPer}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showPaidFeeField = (row) => (
    <>
      {row?.paidFee ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>${row?.paidFee}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">${row?.paidFee}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showPaidField = (row) => (
    <>
      {row?.paid ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.paid}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row?.paid}</div>
        </OverlayTrigger>
      ) : (
        "0"
      )}
    </>
  );

  showActualFeeField = (row) => (
    <>
      {row?.actualFee ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>${row?.actualFee}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">${row?.actualFee}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showActualCitationField = (row) => (
    <>
      {row?.actualCitations ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.actualCitations}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row?.actualCitations}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showIssuedFeeField = (row) => (
    <>
      {row?.issuedFee ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>${row?.issuedFee}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">${row?.issuedFee}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showIssuedCountField = (row) => (
    <>
      {row?.issued ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.issued}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row?.issued}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showMonthField = (row) => (
    <>
      {row?.month ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.month}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row?.month}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showMonField = (row) => (
    <>
      {row.mon ? (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row.mon}</Tooltip>}>
          <div className="text-nowrap text-truncate pr-2">{row.mon}</div>
        </OverlayTrigger>
      ) : (
        "-"
      )}
    </>
  );

  showDomainField = (row) => (
    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{row?.domain}</Tooltip>}>
      <div className="text-nowrap text-truncate pr-2">{row?.domain}</div>
    </OverlayTrigger>
  );

  changeProperty(event) {
    this.setState({
      selectedProperty: event.value,
      selectedPropertyObj: event,
    });
  }

  handleCheckBox = () => {
    this.setState({ childcheckbox: !this.state.childcheckbox });
  };

  componentDidMount = async () => {
    await this.getTickets();
    await this.props.get_all_properties();
    const { PropertyId } = this.state;
    this.setState(
      {
        api_response: this.props?.api_response,
        all_properties: this.props?.getAllProperties,
      },
      async () => {
        const selectedPropertyObj = this.state.all_properties.find((item) => item.id === PropertyId);
        if (selectedPropertyObj) {
          this.setState({
            selectedPropertyObj: {
              label: selectedPropertyObj.site_name,
              value: selectedPropertyObj.id,
            },
            selectedProperty: PropertyId,
            selectedDomainName: selectedPropertyObj.site_name,
          });
        }
      },
    );

    const height = tableHeightScrollBars();
    this.setState({
      finalTableHeight: height,
    });
  };

  getTickets = async () => {
    this.setState({ loader: true }, async () => {
      const { PropertyId, childcheckbox, timezone } = this.state;
      const pageobj = {
        PropertyId,
        timezone,
        childcheckbox,
      };
      await this.props.getReportList(pageobj);
      const selectedPropertyName = this.state.property?.property_name;
      const selectedDomainName = this.state.property?.domain;
      await this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
      this.setState({
        paidUnpaidList: this.props?.paidUnpaidList?.rows?.length ? JSON.parse(JSON.stringify(this.props.paidUnpaidList.rows)) : [],
        api_response: this.props.api_response,
        count: this.props.paidUnpaidList.count,
      });
      this.setState({ loader: false });
    });
  };

  dataTableHandle = (paidUnpaidList) => {
    return (
      <DataTable
        data={this.state.searchValue.length ? this.state.searchedtransactionsList : paidUnpaidList}
        columns={this.columns}
        customStyles={this.customStyles}
        responsive={true}
        defaultSortAsc={true}
        fixedHeader={true}
        onChangePage={scroolToTop}
        fixedHeaderScrollHeight={this.state.finalTableHeight}
        pagination={true}
        paginationPerPage={100}
        paginationTotalRows={this.state.count}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
      />
    );
  };

  handleSearch = () => {
    this.setState({ loader: true }, async () => {
      const { childcheckbox, selectedPropertyObj, PropertyId, timezone } = this.state;
      const pageobj = {
        childcheckbox,
        PropertyId,
        timezone,
      };
      if (Object.keys(selectedPropertyObj).length) {
        pageobj.PropertyId = selectedPropertyObj.value;
      } else {
        pageobj.PropertyId = PropertyId;
      }
      await this.props.getReportList(pageobj);

      this.setState({
        paidUnpaidList: JSON.parse(JSON.stringify(this.props.paidUnpaidList.rows)),
        api_response: this.props.api_response,
        count: this.props.paidUnpaidList.count,
        exportButtonDisable: false,
      });
      this.setState({ loader: false });
      document.body.classList.remove("foc-open");
    });
  };

  handleSearchChange = async ({ target }) => {
    const val = target ? target.value.toString().trim() : this.state.searchValue.toString().trim();

    this.setState({ searchValue: val }, async () => {
      const columnList = [
        "mon",
        "month",
        "issued",
        "issuedFee",
        "actualCitations",
        "actualFee",
        "paid",
        "paidFee",
        "actualPaidPer",
        "unpaid",
        "unpaidFee",
        "actualUnpaidPer",
      ];
      if (this.state.searchValue.length) {
        this.setState(
          {
            searchedtransactionsList: findBySearch(
              this.state.searchValue,
              this.state.paidUnpaidList,
              this.state.paidUnpaidList,
              columnList,
              this.props.timezone,
            ),
          },
          () => {
            this.setState({
              count: this.state.searchedtransactionsList.length,
            });
          },
        );
      } else {
        this.setState({
          count: this.props.paidUnpaidList.count,
          searchedtransactionsList: [],
          paidUnpaidList: this.props.paidUnpaidList.rows,
        });
      }
    });
  };

  resetAll = async () => {
    this.setState({
      selectedPropertyObj: {},
      childcheckbox: true,
      exportButtonDisable: true,
    });
    const { PropertyId, selectedDomainName, timezone } = this.state;
    const pageobj = {
      PropertyId,
      timezone,
    };
    await this.props.getReportList(pageobj);
    this.setState({
      paidUnpaidList: this.props.paidUnpaidList.rows,
      count: this.props.paidUnpaidList.count,
      selectedPropertyObj: {
        label: selectedDomainName,
        value: PropertyId,
      },
    });
    this.setState({ loader: false });
    document.body.classList.remove("foc-open");
  };

  hideSlider = () => {
    document.body.classList.remove("foc-open");
  };

  handleExport = async () => {
    const { childcheckbox, selectedPropertyObj, PropertyId, selectedDomainName, timezone } = this.state;
    const pageobj = {
      childcheckbox,
      PropertyId,
      timezone,
      exportData: true,
    };
    if (Object.keys(selectedPropertyObj).length) {
      pageobj.PropertyId = selectedPropertyObj.value;
    } else {
      pageobj.PropertyId = PropertyId;
    }
    const bufferData = await this.props.getReportList(pageobj);
    const currentTimeDate = moment().format("YYYYMMDD-hhmmss");
    const exportDataName = `PAID_UNPAID_CITATIONS-${currentTimeDate}-${selectedDomainName}.xls`;
    if (bufferData) {
      saveAs(
        new Blob([bufferData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        exportDataName,
      );
    }
  };

  render() {
    const { paidUnpaidList, loader, childcheckbox, searchValue } = this.state;

    return (
      <div>
        <Card className="mb-0">
          <Card.Body className="pos-rel-overflow-hide">
            <>
              <div className="sidebarFilter">
                <Card className="contact-container mb-0">
                  <Card.Header style={{ backgroundColor: this.props.main_body }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <Card.Title as="h4">Paid-Unpaid Citations</Card.Title>
                      <a
                        onClick={this.hideSlider}
                        href="javascript:void(0);"
                        className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </a>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md="12">
                        <div className="mb-2">
                          <label className="fancy-checkbox">
                            <input
                              type="checkbox"
                              name={"childcheckbox"}
                              checked={childcheckbox}
                              onChange={this.handleCheckBox}
                              className="custom-control-input"
                              id="childcheckbox1"
                            ></input>
                            <span>
                              <i></i>Include Children Sites
                            </span>
                          </label>
                        </div>
                      </Col>
                      <Col md="12">
                        <PropertDetails selectedPropertyObj={this.state.selectedPropertyObj} changeProperty={this.changeProperty.bind(this)} />
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer className="text-right justify-content-between d-flex">
                    <Button variant="info" className="h-40 custom-btn-secondary btn-sm" onClick={this.resetAll} disabled={loader}>
                      Reset
                    </Button>
                    <Button variant="info" className="h-40 btn-fill btn-sm ml-2" onClick={this.handleSearch} disabled={loader}>
                      Search
                    </Button>
                  </Card.Footer>
                </Card>
              </div>
              <header>
                <div className="active-permit-header sm-flex-column sm-align-items-start">
                  <h5 className="mb-2 mb-md-0"></h5>
                  <div className="filter-button d-flex flex-wrap">
                    <div className="d-flex align-items-center search-mb-0">
                      <DatatableHeader
                        className="mt-0 mb-0"
                        searchValue={searchValue}
                        HandleChange={this.handleSearchChange}
                        // findMorePressed={this.findMorePressed}
                      />
                    </div>
                    <div className="ml-2">
                      <Button variant="info" className="btn-fill btn-sm" onClick={this.handleExport} disabled={paidUnpaidList.length > 0 ? 0 : 1} size="medium">
                        Export
                      </Button>
                    </div>
                  </div>
                </div>
              </header>
            </>
            {loader ? (
              <Loader />
            ) : (
              <>
                {paidUnpaidList && (
                  <>
                    <div className="citation-list-table citation-analysis-payable">{this.dataTableHandle(paidUnpaidList)}</div>
                    <div style={{ padding: 20, fontSize: 13 }}>
                      <span className="font-weight-600">Payable</span> : Paid, Unpaid (Unpaid, Reduced)
                    </div>
                  </>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({ UserProfileDetails, APIResponseDetails, Logindetails, SuperAdminDetails, TicketDetails }) => {
  const { api_response, api_error_message, api_success_message } = APIResponseDetails;
  const { property_id: PropertyId, timezone, property } = UserProfileDetails;

  const { backgroundColor } = Logindetails;
  const { getAllProperties } = SuperAdminDetails;
  const { MainBackground: main_body } = backgroundColor;
  const { paidUnpaidList } = TicketDetails;
  return {
    api_response,
    api_error_message,
    api_success_message,
    PropertyId,
    timezone,
    property,
    paidUnpaidList,
    main_body,
    getAllProperties,
  };
};

const mapStateToDispatch = {
  setDomainHeader: SuperAdminAction.setDomainHeader,
  get_all_properties: SuperAdminAction.get_all_properties,
  selected_Property: SuperAdminAction.selected_Property,
  getReportList: TicketActions.getPaidUnpaidList,
};

export default connect(mapStateToProps, mapStateToDispatch)(TotalReport);
